import clsx from 'clsx'
import React, {FC, useEffect, useState} from 'react'

type LoadingProps = {
  show: boolean
  text?: string
  black?: boolean
  white?: boolean
  transparency?: number
  type?: 'logo' | 'spinner'
  borderRadius?: number
}

const Loading: FC<LoadingProps> = ({show, text, black, white, transparency, type, borderRadius}) => {
  return (
    <>
      <div
        style={{
          position: 'absolute',
          zIndex: '90',
          top: '0',
          bottom: '0',
          left: '0',
          right: '0',
          display: `${show ? 'flex' : 'none'}`,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          backgroundColor: `rgba(${white ? '255, 255, 255' : black ? '0, 0, 0' : ''}, ${transparency})`,
          lineHeight: '1',
          fontSize: '14px',
          fontWeight: '400',
          margin: '0',
          borderRadius: `${borderRadius}rem`
        }}
      >
        {type == 'logo' && (
          <img
            src='/media/logos/logo_reversed.svg'
            alt='Logo'
            style={{
              marginBottom: '30px',
              height: '45px',
            }}
          />
        )}
        {type == 'spinner' && <div className='spinner-border' style={{width: '3rem', height: '3rem', marginBottom: '15px'}}></div>}
        <span className='text-nowrap'>{text}</span>
      </div>
    </>
  )
}

Loading.defaultProps = {
  text: 'Loading ...',
  black: false,
  white: true,
  transparency: 0.5,
  type: 'logo',
  borderRadius: 0
}

export default Loading
